import utils from "../../../utils/utils";

export const FORM_COLUMN = "Form";

export const FORM_DATE_COLUMNS = ["CreatedAt", "ModifiedAt"];

export const PERSON_FILTER_COLUMNS = ["CreatedByName", "ModifiedByName"];

export const FORM_FIELD_OPTIONS = [
  { key: FORM_COLUMN, label: "Form" },
  { key: "ModuleScope", label: "Scope" },
  { key: "PublishedVersionNo", label: "Published" },
  { key: "DraftVersionNo", label: "Draft" },
  { key: "CreatedAt", label: "Created At" },
  { key: "CreatedByName", label: "Created By" },
  { key: "ModifiedAt", label: "Modified At" },
  { key: "ModifiedByName", label: "Modified By" },
];

export const DEFAULT_FORM_COLUMNS = [
  FORM_COLUMN,
  "ModuleScope",
  "PublishedVersionNo",
  "DraftVersionNo",
  "CreatedAt",
  "CreatedByName",
  "ModifiedAt",
  "ModifiedByName",
];

export const DATE_RANGE_INITIAL = {
  preset: "All Time",
  startDate: "",
  endDate: "",
};

export function formatFormDateTime(value) {
  if (value == null || value === "") return "—";
  const date =
    value instanceof Date ? value : utils.parseDateInput(String(value));
  if (!date || Number.isNaN(date.getTime())) {
    const fallback = new Date(value);
    if (Number.isNaN(fallback.getTime())) return String(value);
    return fallback.toLocaleString();
  }
  return date.toLocaleString();
}

export function matchesDateRange(value, dateRange) {
  if (
    !dateRange ||
    dateRange.preset === "All Time" ||
    (!dateRange.startDate && !dateRange.endDate)
  ) {
    return true;
  }

  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") return false;

  const date = utils.parseDateInput(raw);
  if (!date) return false;

  const startRaw = dateRange.startDate
    ? utils.parseDateInput(dateRange.startDate)
    : null;
  const endRaw = dateRange.endDate
    ? utils.parseDateInput(dateRange.endDate)
    : null;

  if (startRaw) {
    const from = new Date(
      startRaw.getFullYear(),
      startRaw.getMonth(),
      startRaw.getDate(),
      0,
      0,
      0,
      0,
    );
    if (date < from) return false;
  }
  if (endRaw) {
    const to = new Date(
      endRaw.getFullYear(),
      endRaw.getMonth(),
      endRaw.getDate(),
      23,
      59,
      59,
      999,
    );
    if (date > to) return false;
  }
  return true;
}

export function matchesPersonFilter(personName, selectedLabels) {
  if (!Array.isArray(selectedLabels) || selectedLabels.length === 0) return true;
  const label = String(personName || "").trim();
  if (!label) return false;
  return selectedLabels.some(
    (selected) =>
      String(selected).trim().toLowerCase() === label.toLowerCase(),
  );
}

export function buildPersonFilterOptions(rows, field) {
  const set = new Set();
  (rows || []).forEach((row) => {
    const name = String(row?.[field] || "").trim();
    if (name) set.add(name);
  });
  return Array.from(set)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
    .map((name) => ({ value: name, label: name }));
}

export function matchesFormColumnSearch(row, field, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;

  if (field === FORM_COLUMN) {
    const hay = [row?.Code, row?.Name]
      .map((v) => String(v || "").toLowerCase())
      .join(" ");
    return hay.includes(q);
  }

  if (field === "PublishedVersionNo") {
    const label =
      row?.PublishedVersionNo != null ? `v${row.PublishedVersionNo}` : "";
    return label.toLowerCase().includes(q);
  }

  if (field === "DraftVersionNo") {
    const label =
      row?.DraftVersionNo != null ? `v${row.DraftVersionNo}` : "";
    return label.toLowerCase().includes(q);
  }

  return String(row?.[field] ?? "")
    .toLowerCase()
    .includes(q);
}
